import { render } from "./DetailsFlow.vue?vue&type=template&id=3ab801be&ts=true"
import script from "./DetailsFlow.vue?vue&type=script&lang=ts"
export * from "./DetailsFlow.vue?vue&type=script&lang=ts"

import "./DetailsFlow.vue?vue&type=style&index=0&id=3ab801be&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__